import {Injectable} from '@angular/core';
import {PermissionService} from '@shared/service/permission.service';
import {AppConfigEnvironment} from '@shared/models/appconfig-environment.model';
import {AppConfigEnvironmentService} from '@shared/service/appconfig-environment.service';
import {Location} from '@angular/common';
import {BookingsRoutingRoots} from '../bookings-routing-roots';
import { RenterType } from '../models/enums.models';

@Injectable({
	providedIn: 'root'
})
export class BookingFlowService {
	private environment: AppConfigEnvironment;

	constructor(
		private permissionService: PermissionService,
		private appConfig: AppConfigEnvironmentService,
		public location: Location
	) {
		this.environment = this.appConfig.Environment;
	}

	getModule(): string {
		return (this.location.path().includes(BookingsRoutingRoots.RELIEF) ? BookingsRoutingRoots.RELIEF : BookingsRoutingRoots.PRELEASE) as string;
	}

	isRelief(): boolean {
		return this.location.path().includes(BookingsRoutingRoots.RELIEF);
	}

	isPrelease(): boolean {
		return this.location.path().includes(BookingsRoutingRoots.PRELEASE);
	}
	isHistory(): boolean {
		return this.location.path().includes('history');
	}

	isRenterTypeRAC(booking: any): boolean {
		if (
			!booking ||
			!booking.renter ||
			!booking.renter.type
		) {
			return false;
		}
		return booking.renter.type === RenterType.RAC;
	}






	/**
	 *  Restituisce il path base per le chiamate API	
	 * @returns {string } path corrispontente al tipo di percorso e modulo
	 */
	getBasePath(): string {
		//Definizione dei path per le chiamate API
		const paths = {
			booking: { //Richiesta Veicoli
				relief: this.environment.BOOKINGS_RELIEF_API, 
				prelease: this.environment.BOOKINGS_PRELEASE_API 
			},
			bookingshistorical: { //Storico Veicoli
				relief: this.environment.BOOKINGS_HISTORICAL_RELIEF_API, 
				prelease: this.environment.BOOKINGS_HISTORICAL_PRELEASE_API 
			},
		}
		const type = this.isHistory() ? 'bookingshistorical' : 'booking';
		const module = this.getModule();
		return paths[type][module];
	}



}
